<template>
    <div class="single-answer numerical">
        <div class="q-privew" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{ currentQuestion.questionNo }}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div @copy.prevent @contextmenu="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
        </div>
        <div class="ans-part" v-if="showAnswerField" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="que-row">
                <div
                    class="que-col-2"
                    v-if="isPreview || currentQuestion.showAnswerField"
                >
                    <div class="st-tile">
                        <label class="file-title-st">Start Value</label>
                        <v-text-field
                            v-model="currentQuestion.startValue"
                            type="number"
                            :disabled="currentQuestion.disabled  || currentQuestion.isAnswerDisabled"
                            @input="updateAnswer"
                            @keydown.space.prevent
                            @paste.prevent
                            @keypress="allowedOnlyNumber($event)"
                            outlined
                            dense
                            hide-details
							@copy.prevent 
							@contextmenu="rightClickDisable($event)"
                            @mouseup="rightClickDisable($event)"
                        ></v-text-field>
                    </div>
                    <div class="st-tile">
                        <label class="file-title-st">End Value</label>
                        <v-text-field
                            v-model="currentQuestion.endValue"
                            type="number"
                            :disabled="currentQuestion.disabled  || currentQuestion.isAnswerDisabled"
                            @input="updateAnswer"
                            @keydown.space.prevent
                            @paste.prevent
                            @keypress="allowedOnlyNumber($event)"
                            outlined
                            dense
                            hide-details
							@copy.prevent
							@contextmenu="rightClickDisable($event)"
                            @mouseup="rightClickDisable($event)"
                        ></v-text-field>
                    </div>
                </div>
                <div :class="practiceSessionView ? 'que-col-2 py-2 numtypequesn-margin-11feb' : 'que-col-2 py-2'" v-else>
                    <v-text-field
                    :class=" inputColour=='red' ? 'numtypequesn-red' : inputColour=='green' ? 'numtypequesn-green': '' "
                        v-model="currentQuestion.correct_answer"
                        type="number"
                        outlined
                        dense
						@copy.prevent
						 @contextmenu="rightClickDisable($event)"
                         @mouseup="rightClickDisable($event)"
                        hide-details="auto"
                        :disabled="currentQuestion.disabled" 
                        @keypress="validateField($event)"
                        @keyup="disableField($event)"
                        ref="correctAnswer"                        
                    ></v-text-field>
                </div>
            </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row>
                        <v-col cols="5"
                            ><label class="ans-text-3may">Your Answer: </label>{{ currentQuestion.yourAnswer }}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span>
                        </v-col>
                        <v-col cols="6"
                            ><label class="ans-text-3may">Correct Answer:</label>
                            {{ currentQuestion.correctAnswer }}</v-col
                        >
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="currentQuestion.solutionVideos && currentQuestion.solutionVideos.length"
						@copy.prevent @contextmenu="rightClickDisable($event)"
                        @mouseup="rightClickDisable($event)"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div>
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution && currentQuestion.isPreview&& currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
			<div v-else-if="(currentQuestion.solution&&currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import isMobile from "is-mobile";

export default {
    name: "SubjectivePrivew",
    props: ["currentQuestion", "showAnswerField", "isPreview", "practiceSessionView", "inputColour","openMandatoryQuePopup"],
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
    },
    data() {
        return {
            ansLength: null,
        };
    },
    mounted() {
        this.renderMath();
        this.ansLength = this.currentQuestion && this.currentQuestion.correct_answer ? this.currentQuestion.correct_answer.length : 0;
        this.focusOnField();
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        updateAnswer() {
            // this.question.correct_answer = this.startValue + "##" + this.endValue;
            var startValue = this.currentQuestion.startValue
                ? this.currentQuestion.startValue.toString()
                : "";
            var endValue = this.currentQuestion.endValue
                ? this.currentQuestion.endValue.toString()
                : "";
            this.currentQuestion.correct_answer = startValue + "##" + endValue;
        },
        validateField(event) {
            this.allowedOnlyNumberWithDecimal(event);
            if (this.allowedOnlyNumberWithDecimal(event)) {
                this.setDisableSecondaryAction(true);
            }
        },
        disableField(event) {
            if(this.allowedOnlyNumberWithDecimal(event)) {
                this.setDisableSecondaryAction(true);
            }
        },
        focusOnField() {
            if(!isMobile()) {
                if(this.$refs.correctAnswer) {
                    this.$refs.correctAnswer.focus();
                }
            }
        },
        rightClickDisable(e) {
            e.preventDefault();   
        },
        async mandatoryQueCount(){
            await this.openMandatoryQuePopup();
            this.currentQuestion.correct_answer = null;
        }
    },
    watch: {
        "currentQuestion.correct_answer": function (newVal) {
            if (newVal > "") {
                this.currentQuestion.isAnswered = true;
            } else {
                this.currentQuestion.isAnswered = false;
            }
            if(this.currentQuestion.isAnswered && !this.isPreview) {
                this.setDisableSecondaryAction(true);
            }
            if(this.currentQuestion.isAnswerDisabled === true && this.practiceSessionView!==true){
                this.mandatoryQueCount();
            }
        },
        "currentQuestion.id": function (val) {
            this.focusOnField();
            this.setDisableSecondaryAction(false);
            this.renderMath();
            this.renderMath();
        },
    },
};
</script>